import {
  dateFormat,
  formatDateAndTime,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { renderToStaticMarkup } from 'react-dom/server'
import QRCode from 'react-qr-code'
import React from 'react'
import { toHtmlNewLine } from 'helpers/StringNumberFunction/StringConverter'
import { numberToWords } from 'helpers/stringConverter'

const generateQRCodeSVG = value => {
  const qrCodeElement = (
    <QRCode
      size={128}
      style={{ height: '75px', width: '75px' }}
      value={value}
      // viewBox={`0 0 128 128`}
    />
  )
  return renderToStaticMarkup(qrCodeElement)
}

export const ELetterServiceAR = ({
  docType,
  previewDetail,
  allpreviewDetail,
  paramVal,
  ItemIndex,
}) => {
  const debtorDetails = {
    // Debtor Parameters
    '[DebtorName]':
      previewDetail?.DebtorAccount?.CompanyName! ??
      previewDetail?.DebtorAccount?.DebtorName!,
    '[DebtorAddress]': `${previewDetail?.DebtorAccount?.Address?.address}<br />
          ${
            previewDetail?.DebtorAccount?.Address?.country == 'Singapore'
              ? `${previewDetail?.DebtorAccount?.Address?.country} ${previewDetail?.DebtorAccount?.Address?.postCode}`
              : `${previewDetail?.DebtorAccount?.Address?.postCode} ${previewDetail?.DebtorAccount?.Address?.city}, 
            ${previewDetail?.DebtorAccount?.Address?.state}, ${previewDetail?.DebtorAccount?.Address?.country}`
          }
           <br />`,
    '[DebtorCompanyRegNo]': previewDetail?.DebtorAccount?.CompanyRegNo! ?? '',
    '[DebtorSSTRegNo]': previewDetail?.DebtorAccount?.SSTRegNo! ?? '',
    '[DebtorGSTRegNo]': previewDetail?.DebtorAccount?.GSTRegNo! ?? '',
    '[DebtorBankAccName]': previewDetail?.DebtorAccount?.BankName! ?? '',
    '[DebtorBankAccNo]': previewDetail?.DebtorAccount?.BankAccountNo! ?? '',
    '[DebtorEmail]': previewDetail?.DebtorAccount?.Email! ?? '',
    '[DebtorPhoneNo]': previewDetail?.DebtorAccount?.OfficeNo! ?? '',
    '[DebtorMobileNo]': previewDetail?.DebtorAccount?.MobileNo! ?? '',
    '[DebtorTIN]': previewDetail?.DebtorAccount?.einvoice_TIN! ?? '',
    '[DebtorCreditTerm]': previewDetail?.DebtorAccount?.CreditTerm! ?? '',
    '[DebtorType]': previewDetail?.DebtorAccount?.DebtorType?.Name! ?? '',
    /////
    // Debtor Contact Parameters
    '[DebtorContactName]':
      previewDetail?.DebtorAccount?.DebtorContact[0]?.Name! ?? '',
    '[DebtorContactNo]':
      previewDetail?.DebtorAccount?.DebtorContact[0]?.ContactNo! ?? '',
    '[DebtorContactEmail]':
      previewDetail?.DebtorAccount?.DebtorContact[0]?.Email! ?? '',
    /////
    // '[TaxSSTRegNo]': previewDetail?.SSTRegNo! ?? '',
    // '[TaxGSTRegNo]': previewDetail?.GSTRegNo! ?? '',
    // Document Parameters
    '[DocumentNo]': previewDetail?.DocNo! ?? '',
    '[DocumentDate]': dateFormat(previewDetail?.DocDate!) ?? '',
    '[ReferenceNo]': previewDetail?.RefNo! ?? '',
    ////
    // E-Invoice Parameters
    '[QRCode]':
      previewDetail?.is_einvoice && previewDetail?.einvoice_qr_url
        ? generateQRCodeSVG(previewDetail?.einvoice_qr_url)
        : '',
    '[EInvoiceValidatedDate]': previewDetail?.einvoice_validation_date
      ? formatDateAndTime(previewDetail?.einvoice_validation_date)
      : '',
    '[EInvoiceSentDate]': previewDetail?.einvoice_sent_date
      ? formatDateAndTime(previewDetail?.einvoice_sent_date)
      : '',
    '[EInvoiceStatus]': previewDetail?.einvoice_status ?? '',
    '[UIN]': previewDetail?.einvoice_irbm_uniqueID ?? '',
  }

  switch (docType) {
    case 'official-receipt':
      Object.assign(paramVal, debtorDetails, {
        '[CreditTerm]':
          previewDetail?.CreditTerm! ??
          previewDetail?.DebtorAccount?.CreditTerm! ??
          '',
        '[Remark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[DocRemark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[Description]': toHtmlNewLine(previewDetail?.Description!) ?? '',
        '[BankAccName]': previewDetail?.BankAccount?.BankProfile?.Name! ?? '',
        '[BankCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[BankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[DocAmt]': amtStr(previewDetail?.DocAmt) ?? '',
        items: (previewDetail?.itemList ?? []).map((el, i) => ({
          '[Index]': (ItemIndex ?? 0) + i + 1,
          '[AllocationDocDate]': el?.DebitDocDate
            ? dateFormat(el?.DebitDocDate)
            : '',
          '[AllocationDocNo]': el?.DebitDocNo ?? '',
          '[AllocationDescription]': toHtmlNewLine(el?.Description) ?? '',
          '[AllocationAmt]': amtStr(Number(el?.AllocationAmt ?? 0)),
        })),

        // Sum of allocations
        '[SumAllocationAmt]': amtStr(
          (previewDetail?.itemList ?? []).reduce(
            (a, b) => a + Number(b?.AllocationAmt ?? 0),
            0
          )
        ),
        '[SumAllocationAmtWord]': numberToWords(
          (previewDetail?.itemList ?? []).reduce(
            (a, b) => a + Number(b?.AllocationAmt ?? 0),
            0
          )
        ),

        // Unallocated = DocAmt - sum(allocation amounts)
        '[SumUnallocationAmt]': amtStr(
          Number(previewDetail?.DocAmt ?? 0) -
            (previewDetail?.itemList ?? []).reduce(
              (a, b) => a + Number(b?.AllocationAmt ?? 0),
              0
            )
        ),
      })
      break
    case 'refund':
      Object.assign(paramVal, debtorDetails, {
        '[CreditTerm]':
          previewDetail?.CreditTerm! ??
          previewDetail?.DebtorAccount?.CreditTerm! ??
          '',
        '[DocRemark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[Remark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[Description]': toHtmlNewLine(previewDetail?.Description!) ?? '',
        '[BankAccName]': previewDetail?.BankAccount?.BankProfile?.Name! ?? '',
        '[BankCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[BankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt) ?? '',
        '[TotalAmt]': amtStr(previewDetail?.DocAmt) ?? '',
      })
      break
    case 'invoice':
      return Object.assign(paramVal, debtorDetails, {
        '[CreditTerm]':
          previewDetail?.CreditTerm! ??
          previewDetail?.DebtorAccount?.CreditTerm! ??
          '',
        '[DueDate]': dateFormat(previewDetail?.DueDate!) ?? '',
        '[Description]': toHtmlNewLine(previewDetail?.Description!) ?? '',
        '[Remark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[DocRemark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[ExemptedTaxRate]': previewDetail?.TaxExemptionInfo?.[0]
          ?.taxExemptionRate
          ? `${previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionRate}%`
          : '',
        '[ExemptedTaxCode]':
          previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionCode ?? '',
        '[ExemptedTaxReason]':
          previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionReason ?? '',
        '[ExemptedTaxAmount]':
          amtStr(previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionAmount!) ??
          '',

        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[Index]': i + 1,
            '[BillItemName]': el?.BillItem?.Name ?? '',
            '[GLAccountCode]': el?.BillItem?.MasterCOA?.Code ?? '',
            '[GLAccountName]': el?.BillItem?.MasterCOA?.Name ?? '',
            '[ItemRemark]':
              !!el?.Remark && el?.Remark.trim() !== ''
                ? toHtmlNewLine(el?.Remark)
                : toHtmlNewLine(el?.BillItem?.Name) ?? '',
            '[ItemTaxExemptionReason]': el?.TaxExemptionReason! ?? '',
            '[TaxRate]':
              el?.TaxScheme?.TaxSchemeDetail?.length === 1
                ? amtStr(el?.TaxScheme?.TaxSchemeDetail[0]?.taxRate)
                : amtStr(el?.TaxRate) ?? '',
            '[BaseAmt]': el?.Amount !== '' ? amtStr(el?.Amount!) : '',
            '[TaxAmt]': amtStr(el?.TaxAmt!),
            '[TotalAmt]': el?.DocAmt !== '' ? amtStr(el?.DocAmt!) : '',
          }
        }),
        '[SumBaseAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.Amount !== '' && a + Number(b?.Amount), 0)
            .toFixed(2)
        ),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.TaxAmt !== '' && a + Number(b?.TaxAmt), 0)
            .toFixed(2)
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.DocAmt !== '' && a + Number(b?.DocAmt), 0)
            .toFixed(2)
        ),
        '[TotalAmtInWords]': numberToWords(
          (allpreviewDetail?.itemList ?? []).reduce(
            (a, b) => a + Number(b?.DocAmt ?? 0),
            0
          )
        ),
        // Exempted Tax Summary Info
        // exemptedTaxItem: previewDetail?.TaxExemptionInfo?.map(el => {
        //   return {
        //     '[ExemptedTaxReason]': el?.taxExemptionReason! ?? '',
        //     '[ExemptedTaxCode]': el?.taxExemptionCode! ?? '',
        //     '[ExemptedTaxAmount]': amtStr(el?.taxExemptionAmount!) ?? '',
        //     '[ExemptedTaxRate]': el?.taxExemptionRate! ?? '',
        //   }
        // }),
        '[TotalTaxExemptionAmount]':
          previewDetail?.TaxExemptionInfo?.length > 0
            ? amtStr(
                previewDetail?.TaxExemptionInfo?.reduce(
                  (a, b) => a + Number(b?.taxExemptionAmount),
                  0
                )
              )
            : '',
      })
    case 'credit-note':
      return Object.assign(paramVal, debtorDetails, {
        '[CreditTerm]':
          previewDetail?.CreditTerm! ??
          previewDetail?.DebtorAccount?.CreditTerm! ??
          '',
        '[Description]': toHtmlNewLine(previewDetail?.Description!) ?? '',
        '[Remark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[DocRemark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[ExemptedTaxRate]': previewDetail?.TaxExemptionInfo?.[0]
          ?.taxExemptionRate
          ? `${previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionRate}%`
          : '0',
        '[ExemptedTaxCode]':
          previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionCode ?? '0',
        '[ExemptedTaxReason]':
          previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionReason ?? '',
        '[ExemptedTaxAmount]':
          amtStr(previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionAmount!) ??
          '',
        // Item listing
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[Index]': i + 1,
            '[BillItemName]': el?.BillItem?.Name ?? '',
            '[GLAccountCode]': el?.BillItem?.MasterCOA?.Code ?? '',
            '[GLAccountName]': el?.BillItem?.MasterCOA?.Name ?? '',
            '[ItemRemark]':
              !!el?.Remark && el?.Remark.trim() !== ''
                ? toHtmlNewLine(el?.Remark)
                : toHtmlNewLine(el?.BillItem?.Name) ?? '',
            '[ItemTaxExemptionReason]': el?.TaxExemptionReason! ?? '',
            '[TaxRate]':
              el?.TaxScheme?.TaxSchemeDetail?.length === 1
                ? amtStr(el?.TaxScheme?.TaxSchemeDetail[0]?.taxRate)
                : amtStr(el?.TaxRate) ?? '',
            '[BaseAmt]': el?.Amount !== '' ? amtStr(el?.Amount!) : '',
            '[TaxAmt]': amtStr(el?.TaxAmt!),
            '[TotalAmt]': el?.DocAmt !== '' ? amtStr(el?.DocAmt!) : '',
          }
        }),
        // allocItems: previewDetail?.Allocation?.map((el, i) => {
        //   return {
        //     '[AllocIndex]': i + 1,
        //     '[AllocDocDate]': !!el?.DebitDocDate
        //       ? dateFormat(el?.DebitDocDate!)
        //       : '',
        //     '[AllocDocNo]': !!el?.DebitDocNo ? el?.DebitDocNo! : '',
        //     '[AllocDesc]': !!el?.Description ? el?.Description! : '',
        //     '[AllocAmt]': !!el?.AllocationAmt ? amtStr(el?.AllocationAmt!) : '',
        //   }
        // }),
        // Allocation Listing
        allocItems: previewDetail?.Allocation?.map((el, i) => {
          return {
            '[AllocIndex]': i + 1,
            '[AllocDocDate]': dateFormat(el?.DebitDocDate!),
            '[AllocDocNo]': el?.DebitDocNo!,
            '[AllocDesc]': toHtmlNewLine(el?.Description!) ?? '',
            '[AllocAmt]': amtStr(el?.AllocationAmt!),
          }
        }),
        '[SumBaseAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.Amount !== '' && a + Number(b?.Amount), 0)
            .toFixed(2)
        ),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.TaxAmt !== '' && a + Number(b?.TaxAmt), 0)
            .toFixed(2)
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.DocAmt !== '' && a + Number(b?.DocAmt), 0)
            .toFixed(2)
        ),
        // Exempted Tax Summary Info
        // exemptedTaxItem: previewDetail?.TaxExemptionInfo?.map(el => {
        //   return {
        //     '[ExemptedTaxReason]': el?.taxExemptionReason ?? '',
        //     '[ExemptedTaxCode]': el?.taxExemptionCode ?? '',
        //     '[ExemptedTaxAmount]': amtStr(el?.taxExemptionAmount ?? 0),
        //     '[ExemptedTaxRate]': el?.taxExemptionRate ?? '',
        //   }
        // }),
        '[TotalTaxExemptionAmount]':
          previewDetail?.TaxExemptionInfo?.length > 0
            ? amtStr(
                previewDetail?.TaxExemptionInfo?.reduce(
                  (a, b) => a + Number(b?.taxExemptionAmount),
                  0
                )
              )
            : '',
      })
    case 'debit-note':
      return Object.assign(paramVal, debtorDetails, {
        '[CreditTerm]':
          previewDetail?.CreditTerm! ??
          previewDetail?.DebtorAccount?.CreditTerm! ??
          '',
        '[Description]': toHtmlNewLine(previewDetail?.Description!) ?? '',
        '[DocRemark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[DueDate]': dateFormat(previewDetail?.DueDate!) ?? '',
        '[Remark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[ExemptedTaxRate]': previewDetail?.TaxExemptionInfo?.[0]
          ?.taxExemptionRate
          ? `${previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionRate}%`
          : '',
        '[ExemptedTaxCode]':
          previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionCode ?? '',
        '[ExemptedTaxReason]':
          previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionReason ?? '',
        '[ExemptedTaxAmount]':
          amtStr(previewDetail?.TaxExemptionInfo?.[0]?.taxExemptionAmount!) ??
          '',
        items: previewDetail?.ARDebitNoteItem?.map((el, i) => {
          return {
            '[Index]': i + 1,
            '[BillItemName]': el?.BillItem?.Name ?? '',
            '[GLAccountCode]': el?.BillItem?.MasterCOA?.Code ?? '',
            '[GLAccountName]': el?.BillItem?.MasterCOA?.Name ?? '',
            '[ItemRemark]':
              !!el?.Remark && el?.Remark.trim() !== ''
                ? toHtmlNewLine(el?.Remark)
                : toHtmlNewLine(el?.BillItem?.Name) ?? '',
            '[ItemTaxExemptionReason]': el?.TaxExemptionReason! ?? '',
            '[TaxRate]':
              el?.TaxScheme?.TaxSchemeDetail?.length === 1
                ? amtStr(el?.TaxScheme?.TaxSchemeDetail[0]?.taxRate)
                : amtStr(el?.TaxRate) ?? '',
            '[BaseAmt]': el?.Amount !== '' ? amtStr(el?.Amount!) : '',
            '[TaxAmt]': amtStr(el?.TaxAmt!),
            '[TotalAmt]': el?.DocAmt !== '' ? amtStr(el?.DocAmt!) : '',
          }
        }),
        '[SumBaseAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.Amount !== '' && a + Number(b?.Amount), 0)
            .toFixed(2)
        ),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.TaxAmt !== '' && a + Number(b?.TaxAmt), 0)
            .toFixed(2)
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.itemList
            ?.reduce((a, b) => a?.DocAmt !== '' && a + Number(b?.DocAmt), 0)
            .toFixed(2)
        ),
        // Exempted Tax Summary Info
        // exemptedTaxItem: previewDetail?.TaxExemptionInfo?.map(el => {
        //   return {
        //     '[ExemptedTaxReason]': el?.taxExemptionReason! ?? 0,
        //     '[ExemptedTaxCode]': el?.taxExemptionCode! ?? 0,
        //     '[ExemptedTaxAmount]': amtStr(el?.taxExemptionAmount!) ?? 0,
        //     '[ExemptedTaxRate]': el?.taxExemptionRate! ?? 0,
        //   }
        // }),
        '[TotalTaxExemptionAmount]':
          previewDetail?.TaxExemptionInfo?.length > 0
            ? previewDetail?.TaxExemptionInfo?.reduce(
                (a, b) => a + Number(b?.taxExemptionAmount),
                0
              )
            : '',
      })
      break
    case 'advance':
      Object.assign(paramVal, debtorDetails, {
        '[CreditTerm]':
          previewDetail?.CreditTerm! ??
          previewDetail?.DebtorAccount?.CreditTerm! ??
          '',
        '[DocRemark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[Remark]': toHtmlNewLine(previewDetail?.Remark!) ?? '',
        '[Description]': toHtmlNewLine(previewDetail?.Description!) ?? '',
        '[BankAccName]': previewDetail?.BankAccount?.BankProfile?.Name! ?? '',
        '[BankCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[BankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt) ?? '',
        '[TotalAmt]': amtStr(previewDetail?.DocAmt) ?? '',
      })
      break
  }
}
